// src/data/exercises/L6_04.js

const accountOptions = [
  '現金', '当座預金', '備品', '立替金', '支払利息'];

export const L6_04 = {
  title: '簿記　3級（第215-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
      content: {
    parts: [
    { "type": "ruby", "text": "山梨株式会社", "ruby": "やまなし株式会社" },
    { "type": "text", "value": "は、" },
    { "type": "ruby", "text": "従業員個人", "ruby": "じゅうぎょういんこじん" },
    { "type": "text", "value": "が" },
    { "type": "ruby", "text": "負担", "ruby": "ふたん" },
    { "type": "text", "value": "すべき" },
    { "type": "ruby", "text": "物品", "ruby": "ぶっぴん" },
    { "type": "text", "value": "の" },
    { "type": "ruby", "text": "購入代金", "ruby": "こうにゅうだいきん" },
    { "type": "text", "value": "￥290,000を" },
    { "type": "ruby", "text": "立", "ruby": "た" },
    { "type": "text", "value": "て" },
    { "type": "ruby", "text": "替", "ruby": "か" },
    { "type": "text", "value": "えて、" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "支払", "ruby": "しはら" },
    { "type": "text", "value": "った。" }
]

,
      },
      table: {
        options: accountOptions,
      },
      answer: [
        { debitAccount: '立替金', debitAmount: 290000, creditAccount: '現金', creditAmount: 290000 },
      ],

      // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'styled', value: '①「現金で支払った」→現金が減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「立て替えて」→立替金を使う借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
①「現金で支払った」→現金が減少（マイナス）します。

②「立て替えて」→立替金を使う借方（左・Ｄｒ）

`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
          parts: [
          { type: 'styled', value: '①「現金で支払った」→現金が減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '②「立て替えて」→立替金を使う借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
        
      },
    },
  ],
};